module.exports = __webpack_public_path__ + "static/netflix-estacao-3-8874e7740e74c0e8e0ce00a4df0f9d05.jpg";